import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  BaseText,
  Row,
  InitialAvatarIcon,
  ButtonTertiary,
  ChipStatus,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import type { ProfitPreview } from '@/modules/trade/services/profit';
import { computed, onMounted } from 'vue';
import { tradeModule } from '@/modules/trade/store/trade';

interface Props {
  profitPreview: ProfitPreview;
}

interface EmitEvents {
  (event: 'subscribe'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitPreviewContent',
  props: {
    profitPreview: null
  },
  emits: ["subscribe"],
  setup(__props: any) {

const props = __props as {
  profitPreview: ProfitPreview;
};





onMounted(async () => {
  await tradeModule.fetchStatus();
});

const isRLPEnabled = computed(() => {
  return tradeModule.tradeStatus?.isRLPEnabled;
});

const shouldShowRPLButton = computed(() => {
  const hasButton = props.profitPreview.costs.button !== null;

  return hasButton && !isRLPEnabled.value;
});

return { __sfc: true,props, isRLPEnabled, shouldShowRPLButton, Heading, BaseText, Row, InitialAvatarIcon, ButtonTertiary, ChipStatus, HeadingDisplay, NebraskaColors }
}

})